export const LOAD_POSTAL_CODES_BOX = 'LOAD_POSTAL_CODES_BOX';
export const LOAD_POSTAL_CODES_STREET = 'LOAD_POSTAL_CODES_STREET';
